/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2022-12-14 09:47:45
 * @LastEditors: luting
 */
import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Upload, Progress, Icon } from 'sup-ui';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { useIntl } from 'react-intl';
import CustomIcon from 'root/components/Icon';
import messages from './messages';
import styles from './index.less';

const { Dragger } = Upload;

interface IProps {
  height: number;
  url: string
  onError: (data: string) => void
  onUpload?: any
  onDownload?: () => void
  setUploadStatus?: any
}
//  TODO 未做完
const AddBtachFile = (props: IProps, ref: React.Ref<unknown> | undefined) => {
  const { height, url, onError, onDownload, setUploadStatus } = props;
  const { runtimeEnvId } = useSelector((state: reducerStates) => state.envManage);
  const intl = useIntl();
  const [fileList, setFileList] = useState<File[]>([]);
  const [statusInfo, setStatusInfo] = useState({ message: '', status: '' });
  const [percent, setPercent] = useState(0);

  useImperativeHandle(ref, () => ({
    fileList: fileList,
  }));


  const handleDeleteFile = () => {
    // 删除正在上传中的文件
    setFileList([]);
    setStatusInfo({ message: '', status: '' });
    setUploadStatus(true);
  };

  const renderDiffTip = () => {
    const { status, message } = statusInfo;

    switch (status) {
      case 'done':
        return <div className={styles.uploadOk}>上传完成</div>;
      case 'error':
        return <div className={styles.error}>配置文件信息错误，请修改，<span onClick={downloadErrorFile}>下载</span></div>;
      case 'unConnect':
        return <div className={styles.error}>接口链接失败，失败原因：{message}</div>;
      default:
        return <div className={styles.uploading}>正在上传并检测文件信息完整度……</div>;
    }
  };

  const downloadErrorFile = () => {
    if (onError) {
      const { message } = statusInfo;
      onError(message);
    }
  };

  return (
    <div style={{ height }} className={styles.batchFileBox}>
      <Dragger
        showUploadList={false}
        className={`${styles.batchFile}`}
        name='file'
        accept=".xls,.xlsx"
        action={url}
        fileList={fileList}
        headers={{
          Authorization: localStorage.getItem('ticket'),
          'Accept-Language': localStorage.getItem('language'),
          'X-Runtime-Env-Id': runtimeEnvId,
        }}
        onChange={(info: any) => {
          const { status, response, percent } = info.file;
          setFileList(info.fileList);
          setPercent(percent);
          if (typeof response === 'object') {
            // 如果接口连接失败
            setStatusInfo({ message: response?.message, status: 'unConnect' });
            return;
          }
          if (response !== 'success' && status === 'done') {
            // 当返回的结果不是success时 视为失败
            setStatusInfo({ message: response, status: 'error' });
            return;
          }
          if (response === 'success' && status === 'done') {
            // 上传成功时解除添加按钮的禁用
            setUploadStatus(false);
          }
          setStatusInfo({ message: response, status });
        }}
      >
        <CustomIcon type="upload40" style={{ fontSize: 40, color: '#2280fa' }} />
        <div className={styles.upload_hint}>
          {intl.formatMessage(messages.uploadFile)}
          <span style={{ color: ' #2280fa' }}>{intl.formatMessage(messages.clickUpload)}</span>
        </div>
      </Dragger>

      <div style={{ display: fileList.length ? 'flex' : 'none' }} className={styles.fileList}>
        {
          fileList.map((item: any) => <div className={styles.fileItem} key={item.name}>
            <div className={styles.fileName}>
              <div>
                <Icon type="file-excel" style={{ color: '#0AB129' }} />
                {item.name}
              </div>
              <CustomIcon onClick={handleDeleteFile} type="box_close20_white" style={{ fontSize: 16 }} />
            </div>
            <Progress
              percent={percent}
              showInfo={false}
              strokeWidth={3}
              strokeColor="#2280FA"
            />
            {renderDiffTip()}
          </div>)
        }
      </div>
      <div onClick={onDownload} className={styles.export}>{intl.formatMessage(messages.downloadFile)}</div>
    </div >
  );
};

export default forwardRef(AddBtachFile);
